import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import './TestimonialsSection.css';

const TestimonialsSection = ({ animatedItems, testimonialRef }) => {
  return (
    <section className="testimonials-section" ref={testimonialRef}>
      <Container>
        <Row className="justify-content-center text-center mb-5">
          <Col lg={8}>
            <h2 className="section-title">What Our Clients Say</h2>
            <div className="title-underline mx-auto"></div>
            <p className="section-subtitle">
              Trusted by farmers and agricultural businesses around the world
            </p>
          </Col>
        </Row>
        <Row>
          <Col lg={4} className={`mb-4 ${animatedItems.testimonials ? 'testimonial-card-animated' : ''}`} style={{ animationDelay: '0.1s' }}>
            <div className="testimonial-card">
              <div className="testimonial-content">
                <p>
                  "Their poultry solutions have significantly improved our flock health and productivity. 
                  The technical support team is always available to provide guidance and solutions."
                </p>
              </div>
              <div className="testimonial-author d-flex align-items-center">
                <div className="testimonial-avatar">
                  <img src="https://images.pexels.com/photos/220453/pexels-photo-220453.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1" alt="Testimonial author" />
                </div>
                <div className="testimonial-info">
                  <h5 className="author-name">John Anderson</h5>
                  <p className="author-role">Poultry Farmer, USA</p>
                </div>
              </div>
            </div>
          </Col>
          <Col lg={4} className={`mb-4 ${animatedItems.testimonials ? 'testimonial-card-animated' : ''}`} style={{ animationDelay: '0.3s' }}>
            <div className="testimonial-card">
              <div className="testimonial-content">
                <p>
                  "The Large Animal management systems they provided have revolutionized our operations. 
                  We've seen improved animal welfare and a 25% increase in overall efficiency."
                </p>
              </div>
              <div className="testimonial-author d-flex align-items-center">
                <div className="testimonial-avatar">
                  <img src="https://images.pexels.com/photos/774909/pexels-photo-774909.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1" alt="Testimonial author" />
                </div>
                <div className="testimonial-info">
                  <h5 className="author-name">Maria Rodriguez</h5>
                  <p className="author-role">Ranch Owner, Brazil</p>
                </div>
              </div>
            </div>
          </Col>
          <Col lg={4} className={`mb-4 ${animatedItems.testimonials ? 'testimonial-card-animated' : ''}`} style={{ animationDelay: '0.5s' }}>
            <div className="testimonial-card">
              <div className="testimonial-content">
                <p>
                  "Their aquaculture systems are state-of-the-art. We've been able to increase production 
                  while maintaining excellent water quality and fish health."
                </p>
              </div>
              <div className="testimonial-author d-flex align-items-center">
                <div className="testimonial-avatar">
                  <img src="https://images.pexels.com/photos/1222271/pexels-photo-1222271.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1" alt="Testimonial author" />
                </div>
                <div className="testimonial-info">
                  <h5 className="author-name">David Chen</h5>
                  <p className="author-role">Aquaculture Manager, Thailand</p>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default TestimonialsSection;